module.exports = __webpack_public_path__ + "img/nos-produits.2faedfb.png";